import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5 0A2.5 2.5 0 0 0 9 2.5V4H5a2 2 0 0 0-2 2v3a1 1 0 0 0 1 1h.357c1.308 0 2.498.941 2.63 2.242A2.5 2.5 0 0 1 4.5 15H4a1 1 0 0 0-1 1v3a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-.357c0-1.308.941-2.498 2.242-2.63A2.5 2.5 0 0 1 14 19.5v.5a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-4h1.5a2.5 2.5 0 1 0 0-5H20V6a2 2 0 0 0-2-2h-4V2.5A2.5 2.5 0 0 0 11.5 0" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }